import { fetchAchievements } from 'Api/achievements';
import { useEffect, useState } from 'react';

const useAchievements = () => {
  const [achievements, setAchievements] = useState([]);
  useEffect(() => {
    fetchAchievements().then(data => {
      setAchievements(data.achievementsObject);
    });
  }, []);
  return { achievements };
};

export default useAchievements;
